import { BaseComponent } from 'components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { Button } from '../../../../components/Buttons';
import { Checkbox } from '../../../../components/Checkbox';
import { Dropdown } from '../../../../components/Dropdown';
import { FormField } from '../../../../components/FormFields';
import { DecoratorLabel, Input } from '../../../../components/Input';
import { ManualDropdown } from '../../../../components/ManualDropdown';
import { Loader } from '../../../../components/Loader';
import { initiateNewVehicleValue, setNewVehicleValue, deleteVehicleProperty } from '../../actions';
import { selectNewVehicle, selectNewVehicleValue, selectVehicle } from '../../selectors';
import DatePicker from 'react-datepicker';
import { IconRightDecorator } from '../../../../components/Icon/IconRightDecorator';
import { Calendar, Question, CircleTimes } from '../../../../components/Icon';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import { VehicleCreateFieldCompany } from './FieldCompany';
import { VehicleCreateFieldCompanyUser } from './FieldCompanyUser';
import { VehicleCreateFieldBrandName } from './FieldBrandName';
import { VehicleCreateFieldModelName } from './FieldModelName';
import {
  REQUEST_VEHICLE_PROPERTY_UPDATE,
  VEHICLE_BODY_TYPES,
  VEHICLE_COLORS,
  VEHICLE_DRIVE_TYPES,
  VEHICLE_FUEL_TYPES,
  VEHICLE_TRANSMISSION_TYPES,
} from '../../constants';
import { selectWork } from '../../../Api/selectors';
import cn from 'classnames';
import CheckboxComponent from '../../../../containers/App/Components/Checkbox/Checkbox';
import ButtonComponent from '../../../../containers/App/Components/Button/Button';
import styles from './Field.module.css';
import { RETRIEVE_VEHICLE_TVI } from '../../../ORB/constants';
import { retrieveVehicleTVI } from '../../../ORB/actions';
import { Warning } from '../../../../components/Warnings';
import env from '../../../../env';
import { AppClientId } from '../../../Shared/constants';
import {Modal, ModalControls} from "../../../../components/Modal";

dayjs.extend(customParseFormat);
const DROPDOWN_OPTIONS = {};

const MANUAL_DROPDOWN_OPTIONS = {
  transport: ['is_available', 'pickup', 'deliver'],
  body_type: VEHICLE_BODY_TYPES,
  base_color: VEHICLE_COLORS,
  secondary_color: VEHICLE_COLORS,
  transmission_type: VEHICLE_TRANSMISSION_TYPES,
  fuel_type: VEHICLE_FUEL_TYPES,
  power_axle: VEHICLE_DRIVE_TYPES,
};

const Container = styled.div`
  margin-bottom: 8px;
  .formField {
    .label {
      text-transform: capitalize;
      margin-bottom: 6px;
      color: #6c757d;
    }
  }

  .rightDecorationBlock {
    width: 100px;
    display: flex;

    .deleteBtn {
      background-color: #d50046;
    }
  }
`;

const STATE = {
  value: '',
};

/* eslint-disable react/prefer-stateless-function */
class VehicleCreateFieldComp extends BaseComponent {
  constructor(props) {
    super(props, { ...STATE });
  }

  componentDidMount() {
    this.props.initiateValue();
  }

  retrieveVehicleTVI(regplate, meldcode) {
    this.props.retrieveVehicleTVI(regplate, meldcode, res => {
      if (!res.chassisnummer && !meldcode) {
        this.setState({ showGetVinMsg: this.lbl('vehicle.create.vin.meldcodeRequired') });
      }
      if (!res.chassisnummer && meldcode) {
        this.setState({ showGetVinMsg: this.lbl('vehicle.create.vin.meldcodeIncorrect') });
      }
      if (res.chassisnummer) {
        this.props.setValue(`${res.chassisnummer}${meldcode}`, 'vin');
        this.setState({ showGetVinMsg: '' });
      }
    });
  }

  isCheckbox() {
    return (
      [
        'new_from_factory',
        'import',
        'ex_rental',
        'orb_stock_status',
        'damaged',
        'is_taxi',
        'task_labels',
        //only hooikammer installation
        //only show following for hooikammer
        'artikelcode',

      ].indexOf(this.props.type) > -1
    );
  }

  isRadioCheckbox() {
    return (
      ['sell_with_license_plate', 'sell_without_license_plate', 'fix_damages', 'dont_fix_damages'].indexOf(this.props.type) >
      -1
    );
  }

  isTextariaBlock() {
    return ['fix_damages_details'].indexOf(this.props.type) > -1;
  }

  isDate() {
    return ['date_expected', 'date_first_allowance'].indexOf(this.props.type) > -1;
  }

  isDropbox() {
    return this.props.type in DROPDOWN_OPTIONS;
  }

  isManualDropbox() {
    return this.props.type in MANUAL_DROPDOWN_OPTIONS;
  }
  wrap(children) {
    const containsCheckbox = element => {
      if (React.isValidElement(element) && element.props) {
        return typeof element.props.className === 'string' && element.props.className.includes('checkbox');
      }
      return false;
    };

    const isCheckboxComp = React.Children.toArray(children).some(child => containsCheckbox(child));

    if (isCheckboxComp) {
      return <div>{children}</div>;
    } else {
      return (
        <div>
          {this.renderFirstDateAllowanceWarningNotification()}
          <label className="form-label">{this.formFieldLabel()}</label>
          {children}
        </div>
      );
    }
  }

  formFieldLabel() {
    if (this.isCheckbox() || this.isRadioCheckbox()) return null;
    return this.lbl(`vehicle.property.${this.props.type}`);
  }

  dropdown() {
    const vals = DROPDOWN_OPTIONS[this.props.type];

    const options = vals.map(val => ({
      label: this.lbl(`vehicle.property.${this.props.type}.${val}`),
      value: val,
    }));

    const value = options.find(o => o.value == this.props.value);

    return (
      <div className={styles.container}>
        <Dropdown
          className={styles.dropdown}
          options={options}
          value={value}
          onChange={pair => this.props.setValue(pair.value)}
        />
      </div>
    );
  }

  manualDropdown() {
    const vals = MANUAL_DROPDOWN_OPTIONS[this.props.type];

    return (
      <ManualDropdown
        model={'vehicle'}
        key={this.props.type}
        type={this.props.type}
        editable={this.props.type != 'transport'}
        deletable={this.props.vehicle && this.props.vehicle[this.props.type]}
        options={vals}
        onChange={value => this.props.setValue(value)}
        onReset={() => this.props.setValue('')}
        onDeleteValue={value =>
          this.props.deleteProperty(this.props.values?.id, this.props.type, result => {
            if (result === true) {
              this.props.setValue('');
            }
          })
        }
        onManual={value => {
          return this.props.setValue(value, this.props.type + '_manual');
        }}
      />
    );
  }

  renderFirstDateAllowanceWarningNotification() {
    if (!this.state.showFirstDateAllowanceWarningNotification) return '';

    return (
      <Modal mediumWide onClose={() => this.setState({ showFirstDateAllowanceWarningNotification: false })}>
        <strong>{this.lbl('vehicle.property.date_first_allowance_confirmation_msg')}</strong>
        <ModalControls>
          <Button
            style={{ marginRight: '5px' }}
            small
            onClick={() => this.setState({ showFirstDateAllowanceWarningNotification: false }, () => {
              let d = dayjs(this.state.date).format('DD-MM-YYYY');
              this.props.setValue(d);
            })}
          >
            {this.lbl('yes')}
          </Button>
          <Button small onClick={() => this.setState({ showFirstDateAllowanceWarningNotification: false })}>
            {this.lbl('cancel')}
          </Button>
        </ModalControls>
      </Modal>
    );
  }

  datePicker() {
    let format = this.props.value?.charAt(2) == '-' ? 'DD-MM-YYYY' : undefined;
    const isCommercialVehicle = this.props.values.vehicle_purpose === 'commercial';

    let selected = this.props.value && this.props.value !== 'null' && dayjs(this.props.value, format);
    return (
      <div className={cn('d-flex align-items-baseline', styles.containerDatePicker)}>
        <DatePicker
          className={styles.datePicker}
          dateFormat="dd-MM-yyyy"
          selected={selected && selected != 'Invalid Date' && selected.toDate()}
          onChange={date => {
            let dateFormat = this.props.type === 'date_first_allowance' ? 'DD-MM-YYYY' : 'YYYY-MM-DD hh:mm:ss';
            let d = dayjs(date).format(dateFormat);
            if (
              this.props.type === 'date_first_allowance' &&
              dayjs(date).year() < 2025 &&
              isCommercialVehicle &&
              !this.props.values.incoming_invoice_finalized
            ) {
              this.setState({ showFirstDateAllowanceWarningNotification: true, date })
            } else {
              d && this.props.setValue(d);
            }
          }}
        />
        <Calendar className={styles.iconCalendar} />
      </div>
    );
  }

  detailsField() {
    return (
      <div>
        <textarea
          value={this.props.value}
          onChange={evt => this.props.setValue(evt.target.value)}
          className="form-control"
        />
      </div>
    );
  }

  reset() {
    this.setState({ ...STATE });
  }

  render() {
    if (this.props.work) return <Loader small />;

    return <Container>{this.wrap(this.renderField())}</Container>;
  }

  isImportDisabled() {
    return !!this.props?.vehicle?.incoming_invoice;
  }

  renderField() {
    if (this.props.value === undefined) return null;
    let disabled = false;
    if (this.props.type === 'import') disabled = this.isImportDisabled();
    if (this.props.type === 'new_from_factory') disabled = !!this.props.values.incoming_invoice_finalized;

    if (this.isCheckbox()) {
      return (
        <CheckboxComponent
          className="checkbox"
          label={this.lbl(`vehicle.property.${this.props.type}`)}
          checked={this.props.value === '1'}
          onChange={() => {
            const value = this.props.value === '1' ? '0' : '1';
            if (this.props.type === 'new_from_factory' && value === '1') {
              const financial_bpm_gross = this.props.values.financial_bpm_gross;

              if (financial_bpm_gross) {
                this.props.setValue(financial_bpm_gross, 'rest_bpm');
                this.props.setValue(financial_bpm_gross, 'outgoing_rest_bpm');
              }
            }
            return this.props.setValue(value);
          }}
          disabled={disabled}
        />
      );
    }

    if (this.isRadioCheckbox()) {
      let isChecked = false;
      if ((this.props.type == 'sell_with_license_plate' || this.props.type == 'fix_damages') && this.props.value == 1) {
        isChecked = true;
      }
      if (this.props.type == 'sell_without_license_plate' && this.props.values?.sell_with_license_plate == '0') {
        isChecked = true;
      }

      if (this.props.type == 'dont_fix_damages' && this.props.values?.fix_damages == '0') {
        isChecked = true;
      }
      return (
        <CheckboxComponent
          className="checkbox"
          label={this.lbl(`vehicle.property.${this.props.type}`)}
          checked={isChecked}
          onChange={() => {
            const value = this.props.value === '1' ? '0' : '1';

            if (this.props.type == 'sell_with_license_plate' && value === '1') {
              return this.props.setValue(value);
            }
            if (this.props.type == 'sell_without_license_plate' && value === '1') {
              return this.props.setValue('0', 'sell_with_license_plate');
            }
            if (this.props.type == 'fix_damages' && value === '1') {
              return this.props.setValue(value);
            }
            if (this.props.type == 'dont_fix_damages' && value === '1') {
              this.props.setValue('', 'fix_damages_details');
              return this.props.setValue('0', 'fix_damages');
            }

            return this.props.setValue(value);
          }}
        />
      );
    }

    if (this.isTextariaBlock()) {
      return this.detailsField();
    }

    if (this.isDropbox()) {
      return this.dropdown();
    }

    if (this.isManualDropbox()) {
      return this.manualDropdown();
    }

    if (this.isDate()) {
      return this.datePicker();
    }

    switch (this.props.type) {
      case 'regplate':
        return (
          <div className={styles.buttonsLabel}>
            <div className={styles.labelCompany}>
              <input
                className="form-control"
                key={this.props.type}
                value={this.props.value}
                onChange={evt => this.props.setValue(evt.target.value)}
              />
            </div>

            <ButtonComponent
              style="ButtonSoftPrimary"
              disabled={!this.props.values.regplate}
              onClick={() => this.props.fetchFromAutotelex(this.props.value)}
            >
              {this.lbl('vehicle.create.regplate.retrieve')}
            </ButtonComponent>
            {this.props.edit && (
              <ButtonComponent
                style="ButtonSoftDelete"
                disabled={!this.props.vehicle?.regplate}
                onClick={() =>
                  this.props.deleteProperty(this.props.values?.id, 'regplate', result => {
                    if (result === true) {
                      this.props.setValue('');
                    }
                  })
                }
              >
                <CircleTimes />
              </ButtonComponent>
            )}
          </div>
        );
      case 'meldcode':
        return (
          <div>
            <div className={styles.buttonsLabel}>
              <div className={styles.labelCompany}>
                <input
                  className="form-control"
                  key={this.props.type}
                  value={this.props.value}
                  onChange={evt => this.props.setValue(evt.target.value)}
                />
              </div>
              {env.clientId === AppClientId.AUTOWIENTJES && (
                <>
                  <ButtonComponent
                    style="ButtonSoftPrimary"
                    disabled={!this.props.vehicle?.id || !this.props.values?.regplate || this.props.workTVI}
                    onClick={() => this.retrieveVehicleTVI(this.props.values?.regplate, this.props.values?.meldcode)}
                  >
                    {this.props.workTVI ? <Loader small /> : this.lbl('vehicle.create.vin.retrieve')}
                  </ButtonComponent>
                  <div className="winTooltip" title="Enter regplate and meldcode to enable button">
                    <Question/>
                  </div>
                </>
              )}
            </div>
            {!!this.state.showGetVinMsg && <Warning>{this.state.showGetVinMsg}</Warning>}
          </div>
        );
      case 'vin':
        return (
          <div className={styles.buttonsLabel}>
            <div className={styles.labelCompany}>
              <input
                className="form-control"
                key={this.props.type}
                value={this.props.value}
                disabled={this.props.workTVI}
                onChange={evt => this.props.setValue(evt.target.value.toUpperCase())}
              />
            </div>
          </div>
        );

      case 'mileage':
        return (
          <div className={styles.buttonLabel}>
            <div className={styles.labelCompany}>
              <input
                className="form-control"
                key={this.props.type}
                value={this.props.value}
                onChange={evt => this.props.setValue(evt.target.value)}
              />
            </div>
            <div className={styles.decoratorLabel}>KM</div>
          </div>
        );
      case 'creditor_company':
        return (
          <VehicleCreateFieldCompany
            key={this.props.type}
            type={this.props.type}
            onChange={value => this.props.setValue(value)}
            labelSize={'12px'}
          />
        );
        break;
      case 'creditor':
        return (
          <VehicleCreateFieldCompanyUser
            companyId={this.props.values.creditor_company}
            key={`${this.props.type}-${this.props.values.creditor_company}`}
            type={this.props.type}
            onChange={value => this.props.setValue(value)}
          />
        );
      case 'brand_name':
        return (
          <VehicleCreateFieldBrandName
            key={this.props.type}
            type={this.props.type}
            deletable={this.props.vehicle && this.props.vehicle[this.props.type]}
            onReset={() => {
              this.props.setValue('');
              this.props.setValue('', 'model_name');
            }}
            onChange={value => this.props.setValue(value)}
            onDeleteValue={value =>
              this.props.deleteProperty(this.props.values?.id, this.props.type, result => {
                if (result === true) {
                  this.props.setValue('');
                  this.props.setValue('', 'model_name');
                }
              })
            }
            onManual={value => this.props.setValue(value, this.props.type + '_manual')}
          />
        );
        break;
      case 'model_name':
        return (
          <VehicleCreateFieldModelName
            key={this.props.type}
            type={this.props.type}
            deletable={this.props.vehicle && this.props.vehicle[this.props.type]}
            onChange={value => this.props.setValue(value)}
            onReset={() => this.props.setValue('')}
            onDeleteValue={value => this.props.deleteProperty(this.props.values?.id, this.props.type, result => {})}
            onManual={value => this.props.setValue(value, this.props.type + '_manual')}
          />
        );
      case 'model_info':
        return (
          <input
            className="form-control"
            key={this.props.type}
            value={this.props.value}
            onChange={evt => this.props.setValue(evt.target.value)}
          />
        );
      case 'power':
        return (
          <div className={styles.buttonLabel}>
            <div className={styles.labelCompany}>
              <input
                className="form-control"
                key={this.props.type}
                value={this.props.value}
                onChange={evt => this.props.setValue(evt.target.value)}
              />
            </div>
            <div className={styles.decoratorLabel}>KW</div>
          </div>
        );
      case 'battery_capacity':
        return (
          <div className={styles.buttonLabel}>
            <div className={styles.labelCompany}>
              <input
                className="form-control"
                key={this.props.type}
                value={this.props.value}
                onChange={evt => this.props.setValue(evt.target.value)}
              />
            </div>
            <div className={styles.decoratorLabel}>KW/h</div>
          </div>
        );
      case 'nedcCo2Emission':
      case 'wltpCo2Emission':
        return (
          <div className={styles.buttonLabel}>
            <div className={styles.labelCompany}>
              <input
                className="form-control"
                key={this.props.type}
                value={this.props.value}
                onChange={evt => this.props.setValue(evt.target.value)}
              />
            </div>
            <div className={styles.decoratorLabel}>g/KM</div>
          </div>
        );

      case 'helga_id':
        return (
          <input
            className="form-control"
            key={this.props.type}
            value={this.props.value}
            onChange={evt => this.props.setValue(evt.target.value)}
          />
        );
      case 'co2_rdw':
        return (
          <div className={styles.buttonLabel}>
            <div className={styles.labelCompany}>
              <input
                className="form-control"
                key={this.props.type}
                value={this.props.value}
                onChange={evt => this.props.setValue(evt.target.value)}
              />
            </div>
            <div className={styles.decoratorLabel}>g/KM</div>
          </div>
        );
      case 'verbruik':
        return (
          <div className={styles.buttonLabel}>
            <div className={styles.labelCompany}>
              <input
                className="form-control"
                key={this.props.type}
                value={this.props.value}
                onChange={evt => this.props.setValue(evt.target.value)}
              />
            </div>
            <div className={styles.decoratorLabel}>L/100KM</div>
          </div>
        );
      case 'energy_label':
        return (
          <Input
            className="form-control"
            key={this.props.type}
            value={this.props.value}
            onChange={evt => this.props.setValue(evt.target.value)}
          />
        );
      case 'euro_class':
        return (
          <div className={styles.buttonsLabel}>
            <div className={styles.labelCompany}>
              <Input
                className="form-control"
                key={this.props.type}
                value={this.props.value}
                onChange={evt => this.props.setValue(evt.target.value)}
              />
            </div>
          </div>
        );
      case 'helga_id':
        return (
          <input
            className="form-control"
            key={this.props.type}
            value={this.props.value}
            onChange={evt => this.props.setValue(evt.target.value)}
          />
        );
      case 'articlecode':
        return (
          <input
            className="form-control"
            key={this.props.type}
            value={this.props.value}
            onChange={evt => this.props.setValue(evt.target.value)}
          />
        );
        case 'category_id':
        return (
          <input
            className="form-control"
            key={this.props.type}
            value={this.props.value}
            onChange={evt => this.props.setValue(evt.target.value)}
          />
        );
    }
  }
}

VehicleCreateFieldComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    work: selectWork(REQUEST_VEHICLE_PROPERTY_UPDATE),
    workTVI: selectWork(RETRIEVE_VEHICLE_TVI),
    value: selectNewVehicleValue(ownProps.type),
    values: selectNewVehicle(),
    vehicle: selectVehicle(ownProps.vehicle_id),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    setValue(value, name = null) {
      name = name ?? ownProps.type;
      dispatch(setNewVehicleValue(name, value));
    },
    deleteProperty(vehicleId, propertyName, callback) {
      dispatch(deleteVehicleProperty(vehicleId, propertyName, callback));
    },
    initiateValue() {
      dispatch(initiateNewVehicleValue(ownProps.type));
    },
    retrieveVehicleTVI(regplate, meldcode, callback) {
      dispatch(retrieveVehicleTVI(regplate, meldcode, callback));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const VehicleCreateField = compose(withConnect, withRouter)(VehicleCreateFieldComp);
